import { forwardRef, useEffect, useRef, useState } from 'react';
import styles from './ProductImage.module.css';
import type { ProductImageProps } from './ProductImage.types';

const ProductImage = forwardRef<HTMLImageElement, ProductImageProps>(
  ({ src, alt }, ref) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [aspectRatio, setAspectRatio] = useState<number>(4 / 3); // default
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      const img = new Image();
      img.src = src;

      img.onload = () => {
        if (img.width && img.height) {
          setAspectRatio(img.height / img.width);
        }
      };
    }, [src]);

    return (
      <div
        ref={containerRef}
        className={styles.wrapper}
        style={{ paddingBottom: `${aspectRatio * 100}%` }}
      >
        {!isLoaded && <div className={styles.imageSkeleton} />}
        <img
          ref={ref}
          src={src}
          alt={alt}
          className={styles.imageStyle}
          loading="lazy"
          onLoad={() => setIsLoaded(true)}
        />
      </div>
    );
  }
);

ProductImage.displayName = 'ProductImage';

export default ProductImage;
